import React, {useEffect, useState} from "react";
import {Box} from "@mui/material";
import {useLanguage} from "../../contexts/LanguageContext";
import { logger } from "../../store/middleware/consoleEventLogger";
import {useNavigate} from "react-router-dom";
import {getSessionStatus} from "../../services/faceLiveness";

const QRCodeSection = ({sessionId, redirectUrl}) => {
  const {t, language} = useLanguage();
  const navigate = useNavigate();
  const qrCodeScanInterval = 3000;

  const [qrCodeUrl, setQrCodeUrl] = useState(null);

  useEffect(() => {
    if (!sessionId) return;

    let interval;

    const fetchStatus = async () => {
      try {
        const response = await getSessionStatus(sessionId);
        const data = response?.data;
        if (!data) return;

        // Set QR code URL on first fetch
        if (data.qr_code_url && !qrCodeUrl) {
          setQrCodeUrl(data.qr_code_url);
        }

        if (data.status === "scanned" || data.status === "started") {
          clearInterval(interval);
          const currentRedirectUrl = response?.data?.redirect_url || redirectUrl;
          navigate("/loading-qr-code", {
            state: {
              sessionId,
              currentRedirectUrl,
              language
            }
          });
        }
      } catch (err) {
        logger.error("QR polling error:", err);
      }
    };

    // Initial fetch
    fetchStatus();

    // Poll every second
    interval = setInterval(fetchStatus, qrCodeScanInterval);

    return () => clearInterval(interval);
  }, [
    sessionId,
    redirectUrl,
    language,
    navigate,
    qrCodeUrl,
    t.landingPage.cameraAuthorization
  ]);

  if (!qrCodeUrl) {
    return null; // or a spinner if you want
  }

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "white",
        borderRadius: 4,
        boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Box
        component="img"
        src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
          qrCodeUrl
        )}`}
        alt="QR Code"
        sx={{width: 200, height: 200}}
      />
    </Box>
  );
};

export default QRCodeSection;
